import { render, staticRenderFns } from "./VerwaltungListBearbeiten.vue?vue&type=template&id=90cdd496&"
import script from "./VerwaltungListBearbeiten.vue?vue&type=script&lang=js&"
export * from "./VerwaltungListBearbeiten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports